/**
 * Date-extensions locale Tamil [ta]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ta', {
    monthNames: ['ஜனவரி','பிப்ரவரி','மார்ச்','ஏப்ரல்','மே','ஜூன்','ஜூலை','ஆகஸ்ட்','செப்டெம்பர்','அக்டோபர்','நவம்பர்','டிசம்பர்'],
    monthShortNames: ['ஜனவரி','பிப்ரவரி','மார்ச்','ஏப்ரல்','மே','ஜூன்','ஜூலை','ஆகஸ்ட்','செப்டெம்பர்','அக்டோபர்','நவம்பர்','டிசம்பர்'],
    dayNames: ['ஞாயிற்றுக்கிழமை','திங்கட்கிழமை','செவ்வாய்கிழமை','புதன்கிழமை','வியாழக்கிழமை','வெள்ளிக்கிழமை','சனிக்கிழமை'],
    dayShortNames: ['ஞாயிறு','திங்கள்','செவ்வாய்','புதன்','வியாழன்','வெள்ளி','சனி']
});
